import { ToastrService } from 'ngx-toastr';
import { of, pipe } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { Master } from '../code';
import { RecordService } from '../services';
import { State } from '../services/work.state';

export const startSearch = (recordSvc: RecordService, toastr: ToastrService) =>
  pipe(
    switchMap(([state, currentState]: [Partial<State>, State]) => {
      if (state.system?.startSearch) {
        if (
          currentState.master?.recordId !== undefined &&
          currentState.master?.recordId > 0
        ) {
          toastr.error('Record already selected');

          const newState = {
            ...state,
            ...{
              system: {
                ...state.system,
                ...{
                  startSearch: undefined,
                },
              },
            },
          };
          return of([newState, currentState] as [Partial<State>, State]);
        } else {
          return recordSvc
            .startSearch$(
              {
                campaignId: state.master?.campaignId!,
                phone: state.system?.startSearch.autoSearch
                  ? state.master?.phone1 || currentState.master?.phone1
                  : undefined,
              },
              state.system!.startSearch!
            )
            .pipe(
              map((result) => {
                if (result.type == 'new') {
                  return [
                    {
                      ...state,
                      ...{
                        system: {
                          ...state.system,
                          ...{
                            startSearch: undefined,
                            startSearchResult: result.type,
                            previousAnswers: undefined,
                          },
                        },
                        master: {
                          ...state.master,
                          ...{
                            recordId: result.recordId,
                          },
                        },
                        action: {
                          ...state.action,
                          ...{
                            attempt: -1,
                          },
                        },
                      },
                    },
                    currentState,
                  ] as [Partial<State>, State];
                } else if (result.type == 'existing') {
                  const master = state.master;
                  const existingProps = master
                    ? (Object.keys(master) as (keyof Master)[])
                        .filter(
                          (k) =>
                            k !== 'recordId' &&
                            k !== 'campaignId' &&
                            k !== 'phone1' &&
                            master[k] !== undefined &&
                            master[k] !== null
                        )
                        .reduce(
                          (prev, curr) => ({ ...prev, [curr]: master[curr] }),
                          {} as Master
                        )
                    : ({} as Master);
                  return [
                    {
                      ...state,
                      ...{
                        system: {
                          ...state.system,
                          ...{
                            startSearch: undefined,
                            startSearchResult: result.type,
                            previousAnswers: result.record.qFields,
                          },
                        },
                        master: {
                          ...result.record.master,
                          ...existingProps,
                        },
                        action: {
                          ...state.action,
                          ...{
                            attempt: -1,
                          },
                        },
                      },
                    },
                    currentState,
                  ] as [Partial<State>, State];
                } else {
                  //result.type = 'cancel'
                  return [
                    {
                      ...state,
                      ...{
                        system: {
                          ...state.system,
                          ...{
                            startSearch: undefined,
                            startSearchResult: result.type,
                            navToQ: undefined,
                          },
                        },
                      },
                    },
                    currentState,
                  ] as [Partial<State>, State];
                }
              })
            );
        }
      }
      return of([state, currentState] as [Partial<State>, State]);
    })
  );
